<template>
  <div>
    <a-menu
      :defaultSelectedKeys="['2-1']"
      :defaultOpenKeys="['2']"
      mode="inline"
      theme="dark"
      :inlineCollapsed="collapsed"
    >
      <a-menu-item key="1" @click="hrefSrc('1')">
        <a-icon type="home" />
        <span>返回主界面</span>
      </a-menu-item>
      <a-sub-menu key="2">
        <span slot="title">
          <a-icon type="audit" />
          <span>工单管理</span>
        </span>
        <a-menu-item key="2-1" @click="hrefSrc('2-1')">公寓列表</a-menu-item>
        <!-- <a-menu-item key="2-3" @click="hrefSrc('2-3')">待排期工单</a-menu-item> -->
        <a-menu-item key="2-4" @click="hrefSrc('2-4')">待分配工单</a-menu-item>
        <a-menu-item key="2-2" @click="hrefSrc('2-2')">工单列表</a-menu-item>
        <!-- <a-menu-item key="2-3" @click="hrefSrc('2-5')">下载</a-menu-item> -->
      </a-sub-menu>
      <a-sub-menu key="4">
        <span slot="title">
          <a-icon type="line-chart" />
          <span>运营数据</span>
        </span>
        <a-menu-item key="4-1" @click="hrefSrc('4-1')">员工战报</a-menu-item>
        <a-menu-item key="4-2" @click="hrefSrc('4-2')">项目战报</a-menu-item>
      </a-sub-menu>
      <a-sub-menu key="5">
        <span slot="title">
          <a-icon type="shopping-cart" />
          <span>物料管理</span>
        </span>
        <a-menu-item key="5-1" @click="hrefSrc('5-1')">公司物料</a-menu-item>
        <a-menu-item key="5-2" @click="hrefSrc('5-2')">员工物料</a-menu-item>
        <a-menu-item key="5-3" @click="hrefSrc('5-3')">申请记录</a-menu-item>
        <a-menu-item key="5-4" @click="hrefSrc('5-4')">出入库记录</a-menu-item>
      </a-sub-menu>
      <a-sub-menu key="3">
        <span slot="title">
          <a-icon type="smile" />
          <span>权限管理【公寓服务】</span>
        </span>
        <a-menu-item key="3-1" @click="hrefSrc('3-1')">员工</a-menu-item>
        <a-menu-item key="3-2" @click="hrefSrc('3-2')">管理员</a-menu-item>
        <a-menu-item key="3-3" @click="hrefSrc('3-3')">客户员工</a-menu-item>
      </a-sub-menu>
    </a-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {
      collapsed: false
    };
  },
  methods: {
    hrefSrc(key) {
      switch (key) {
        case "1":
          this.$router.push({ name: "home" });
          break;
        case "2-1":
          this.$router.push({ name: "cleanHouse" });
          break;
        case "2-2":
          this.$router.push({ name: "cleanOrder" });
          break;
        case "2-3":
          this.$router.push({ name: "cleanWaitSchedule" });
          break;
        case "2-4":
          this.$router.push({ name: "cleanWaitWork" });
          break;
        case "3-1":
          this.$router.push({ name: "cleanCleaner" });
          break;
        case "3-2":
          this.$router.push({ name: "cleanAdmin" });
          break;
        case "3-3":
          this.$router.push({ name: "cleanOwner" });
          break;
        case "3-4":
          this.$router.push({ name: "cleanArea" });
          break;
        case "4-1":
          this.$router.push({ name: "cleanSettlement" });
          break;
        case "4-2":
          this.$router.push({ name: "cleanProSettle" });
          break;
        case "5-1":
          this.$router.push({ name: "cleanMaterialCompany" });
          break;
        case "5-2":
          this.$router.push({ name: "cleanMaterialWorker" });
          break;
        case "5-3":
          this.$router.push({ name: "cleanApplyLog" });
          break;
        case "5-4":
          this.$router.push({ name: "cleanWarehouseLog" });
          break;
      }
    }
  }
};
</script>
